import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { AuthShell } from "@/pages/auth/AuthShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { apiErr } from "@/lib/api";
import { toast } from "sonner";
import { Loader2, LayoutDashboard, Radio } from "lucide-react";

export default function ManagerLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success(`Bienvenue, ${u.first_name} !`);
      navigate(u.role === "admin" ? "/admin" : "/manager");
    } catch (err) { toast.error(apiErr(err)); } finally { setLoading(false); }
  };

  return (
    <AuthShell title="Espace Gestionnaire" subtitle="Connectez-vous pour gérer votre chaîne">
      <div className="flex justify-center -mt-2 mb-4">
        <span className="w-12 h-12 rounded-2xl bg-rdcgold/15 text-rdcgold flex items-center justify-center"><LayoutDashboard size={24} /></span>
      </div>
      <form onSubmit={submit} className="space-y-3">
        <Input type="email" placeholder="Email professionnel" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="mgr-login-email" />
        <Input type="password" placeholder="Mot de passe" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="mgr-login-password" />
        <div className="text-right"><Link to="/forgot-password" className="text-xs text-primary hover:underline" data-testid="mgr-forgot-link">Mot de passe oublié ?</Link></div>
        <Button type="submit" disabled={loading} className="w-full h-11 font-semibold" data-testid="mgr-login-submit">
          {loading ? <Loader2 className="animate-spin" size={18} /> : "Accéder à mon espace"}
        </Button>
      </form>
      <div className="mt-5 rounded-xl bg-secondary/50 p-3 text-center">
        <p className="text-xs text-muted-foreground flex items-center justify-center gap-1.5">
          <Radio size={13} /> Vous n'avez pas encore de chaîne ?
        </p>
        <Link to="/register-media" className="text-sm text-rdcgold font-semibold hover:underline" data-testid="mgr-goto-register">Inscrire mon média</Link>
      </div>
      <p className="text-xs text-center text-muted-foreground mt-4">Simple utilisateur ? <Link to="/login" className="text-primary hover:underline" data-testid="mgr-goto-login">Connexion standard</Link></p>
    </AuthShell>
  );
}
